import type { EditorCommand } from '@atlaskit/editor-common/types';

import { malleableUiPluginKey } from '../pm-plugins/plugin-key';
import type { RemixThinkingPluginMeta } from '../pm-plugins/remix-thinking-plugin';
import { remixThinkingPluginKey } from '../pm-plugins/remix-thinking-plugin';

export const stopRemixThinking =
	({ reopenModal }: { reopenModal?: boolean } = {}): EditorCommand =>
	({ tr }) => {
		const thinkingMeta: RemixThinkingPluginMeta = {
			isThinking: false,
			preserveSavedSelection: !!reopenModal,
		};

		tr.setMeta(remixThinkingPluginKey, thinkingMeta);

		if (reopenModal) {
			tr.setMeta(malleableUiPluginKey, { isRemixModalOpen: true });
		}

		return tr;
	};
